//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      confirmDisabled: true
    };
  },
  props: ['selectedProjects', 'onDelete'],
  methods: {
    confirmDelete: function confirmDelete() {
      this.onDelete();
      this.hide();
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.confirmDisabled = false;
    }, 2000);
  }
};